@if (editOrderInfoLoadingProgress) {
  <div style="height: 100vh" class="centered-loading">
    <p-progress-spinner ariaLabel="loading" />
  </div>
}
@if (editOrderDetails$ | async; as editOrderDetails) {
  <div class="grid col-offset-1 w-10">
    <div class="col-12 mt-6 mb-6">
      <h1 class="orders">{{ 'OrderDetails.Order' | translate }} #{{ orderId }}</h1>
      <div class="yellow-underline"></div>
    </div>
    <div class="col-12 flex p-0">
      <div class="col-12 p-0">
        <div class="col-12 flex p-0">
          <div class="col-4">
            <span class="heading-label"> {{ 'OrderDetails.Created' | translate }}: </span>
          </div>
          <div class="col-8">
            <span class="large-paragraph">{{ editOrderDetails?.created | date: dateFormatWithTime }} </span>
            @if (editOrderDetails.days === 0) {
              <span class="large-paragraph"> ({{ 'OrderDetails.Today' | translate }}) </span>
            }
            @if (editOrderDetails.days !== 0) {
              <span class="large-paragraph">
                ({{ editOrderDetails.days }}
                {{
                  editOrderDetails.days > days
                    ? ('OrderDetails.DaysAgo' | translate)
                    : ('OrderDetails.DayAgo' | translate)
                }})
              </span>
            }
          </div>
        </div>
        <div class="col-12 flex p-0">
          <div class="col-4">
            <span class="heading-label"> {{ 'OrderDetails.Confirmed' | translate }}: </span>
          </div>
          <div class="col-8">
            <span class="large-paragraph">{{ editOrderDetails.confirmed | date: dateFormatWithTime }}</span>
            @if (editOrderDetails.confirmDays === 0) {
              <span class="large-paragraph"> ({{ 'OrderDetails.Today' | translate }}) </span>
            }
            @if (editOrderDetails.confirmDays !== 0) {
              <span class="large-paragraph">
                ({{ editOrderDetails.confirmDays }}
                {{
                  editOrderDetails.confirmDays > days
                    ? ('OrderDetails.DaysAgo' | translate)
                    : ('OrderDetails.DayAgo' | translate)
                }})
              </span>
            }
          </div>
        </div>
        <div class="col-12 flex p-0">
          <div class="col-4">
            <span class="heading-label">{{ 'OrderDetails.Status' | translate }}: </span>
          </div>
          <div class="col-8">
            <p-tag [class]="getOrderStatusStyle(editOrderDetails?.statusId)">
              <div class="flex align-items-center gap-2">
                <span class="p-tag-text">{{ editOrderDetails?.status }}</span>
              </div>
            </p-tag>
          </div>
        </div>
        <div class="col-12 flex p-0">
          <div class="col-4">
            <span class="heading-label">{{ 'OrderDetails.Tests' | translate }}:</span>
          </div>
          <div class="col-8">
            <span class="large-paragraph">{{ editOrderDetails?.testName }}</span>
            <br />
            <span class="large-paragraph">{{ editOrderDetails?.tests }}</span>
          </div>
        </div>
        @if (!editOrderDetails?.noGenes) {
          <div class="col-12 flex p-0">
            <div class="col-4">
              <span class="heading-label capitalize-text">{{ 'Common.Genes' | translate }}:</span>
            </div>
            <div class="col-8">
              <span class="large-paragraph">{{ 'Common.InfoNotAvailable' | translate }}</span>
            </div>
          </div>
        }
        @if (editOrderDetails?.noGenes) {
          <div class="col-12 flex p-0">
            <div class="col-4">
              <span class="heading-label capitalize-text">
                {{ 'Common.Genes' | translate }} ({{ editOrderDetails?.noGenes }}):
              </span>
            </div>
            <div class="col-8">
              <span class="normal-paragraph">{{ editOrderDetails?.geneContent }}</span>
            </div>
          </div>
        }
        <div class="col-12 flex p-0">
          <div class="col-4">
            <span class="download-results">{{ 'OrderDetails.DownloadResults' | translate }}:</span>
          </div>
          @for (orderResultsPdfInfo of orderResultsPdfInfo$ | async; track orderResultsPdfInfo) {
            <div class="col-8 flex align-items-center">
              <p-button
                icon="pi pi-download"
                label="{{ orderResultsPdfInfo.fileDownloadName }}"
                styleClass="p-button-rounded"
                (onClick)="downloadOrderResults(orderResultsPdfInfo.fileDownloadName)"
                [loading]="downloadInProgress" />
            </div>
          }
        </div>
      </div>
    </div>
    <div class="border-gray mt-2 mb-4 ml-2 mr-2 w-12"></div>
    <div class="col-12 flex p-0">
      <div class="col-6 p-0">
        <div class="col-12 flex p-1">
          <h4>{{ 'OrderDetails.PrimaryPatient' | translate }}</h4>
        </div>
        <div class="col-12 flex p-0">
          <div class="col-6">
            <span class="heading-label"> {{ 'OrderDetails.Name' | translate }}: </span>
          </div>
          <div class="col-6">
            <span class="large-paragraph">{{ editOrderDetails.patient }} </span>
          </div>
        </div>
        <div class="col-12 flex p-0">
          <div class="col-6">
            <span class="heading-label"> {{ 'OrderDetails.DateOfBirth' | translate }}: </span>
          </div>
          <div class="col-6">
            <span class="large-paragraph">{{ editOrderDetails.dob | date: dateFormat }}</span>
          </div>
        </div>
        <div class="col-12 flex p-0">
          <div class="col-6">
            <span class="heading-label"> {{ 'OrderDetails.Gender' | translate }}: </span>
          </div>
          <div class="col-6">
            <span class="large-paragraph">{{ editOrderDetails.gender }}</span>
          </div>
        </div>
        <div class="col-12 flex p-0">
          <div class="col-6">
            <span class="heading-label"> {{ 'OrderDetails.Email' | translate }}: </span>
          </div>
          <div class="col-6">
            <span class="large-paragraph break-word">{{ editOrderDetails.email }}</span>
          </div>
        </div>
        <div class="col-12 flex p-0">
          <div class="col-6">
            <span class="heading-label"> {{ 'OrderDetails.Phone' | translate }}: </span>
          </div>
          <div class="col-6">
            <span class="large-paragraph">{{ editOrderDetails.phone }}</span>
          </div>
        </div>
        <div class="col-12 flex p-0">
          <div class="col-6">
            <span class="heading-label"> {{ 'OrderDetails.Id' | translate }}: </span>
          </div>
          <div class="col-6">
            <span class="large-paragraph">{{ editOrderDetails.patientMedicalRecordNumber }}</span>
          </div>
        </div>
        <div class="col-12 flex p-0">
          <div class="col-6">
            <span class="heading-label"> {{ 'OrderDetails.SampleType' | translate }}: </span>
          </div>
          <div class="col-6">
            <span class="large-paragraph">{{ editOrderDetails.sample }}</span>
          </div>
        </div>

        <div class="col-12 flex p-0">
          <div class="col-6">
            <span class="heading-label"> {{ 'OrderDetails.SampleBarcode' | translate }}: </span>
          </div>
          <div class="col-6">
            <span class="large-paragraph">{{ editOrderDetails.barcode }}</span>
          </div>
        </div>
        <div class="col-12 flex p-0">
          <div class="col-6">
            <span class="heading-label"> {{ 'OrderDetails.CollectionDate' | translate }}: </span>
          </div>
          <div class="col-6">
            <span class="large-paragraph">{{ editOrderDetails.collectionDate | date: dateFormat }}</span>
          </div>
        </div>
      </div>
      <div class="col-6 p-0">
        @for (relatedPatient of editOrderDetails.relatedPatients; track relatedPatient; let i = $index) {
          <div>
            <div class="col-12 flex">
              <h5>{{ 'Patient_Info.Patient' | translate }} {{ i + 2 }}</h5>
            </div>
            <div class="col-12 flex p-0">
              <div class="col-6">
                <span class="heading-label">{{ 'OrderDetails.Name' | translate }}: </span>
              </div>
              <div class="col-6">
                <span class="large-paragraph">{{ relatedPatient.firstName + ' ' + relatedPatient.lastName }}</span>
              </div>
            </div>
            <div class="col-12 flex p-0">
              <div class="col-6">
                <span class="heading-label">{{ 'OrderDetails.DateOfBirth' | translate }}: </span>
              </div>
              <div class="col-6">
                <span class="large-paragraph">{{ relatedPatient.dateOfBirth | date: dateFormat }}</span>
              </div>
            </div>
            <div class="col-12 flex p-0">
              <div class="col-6">
                <span class="heading-label"> {{ 'OrderDetails.RelatedPatient' | translate }}: </span>
              </div>
              <div class="col-6">
                @if (patientRelationTypes$ | async; as patientRelationTypes) {
                  <span class="large-paragraph">{{
                    getPatientRelationLabel(patientRelationTypes, relatedPatient.patientRelationTypeId)
                  }}</span>
                }
              </div>
            </div>
            <div class="col-12 flex p-0">
              <div class="col-6">
                <span class="heading-label">{{ 'OrderDetails.SampleType' | translate }}: </span>
              </div>
              <div class="col-6">
                @if (sampleTypes$ | async; as sampleTypes) {
                  <span class="large-paragraph">{{
                    getSampleTypeLabel(sampleTypes, relatedPatient.sampleTypeId)
                  }}</span>
                }
              </div>
            </div>
            <div class="col-12 flex p-0">
              <div class="col-6">
                <span class="heading-label">{{ 'OrderDetails.SampleBarcode' | translate }}: </span>
              </div>
              <div class="col-6">
                <span class="large-paragraph">{{ relatedPatient.barcode }}</span>
              </div>
            </div>
            <div class="col-12 flex p-0">
              <div class="col-6">
                <span class="heading-label">{{ 'OrderDetails.CollectionDate' | translate }}: </span>
              </div>
              <div class="col-6">
                <span class="large-paragraph">{{ relatedPatient.collectionDate | date: dateFormat }}</span>
              </div>
            </div>
            @if (editOrderDetails.relatedPatients.length > 1 && i < editOrderDetails.relatedPatients.length - 1) {
              <div class="border-gray mt-2 mb-4 ml-2 mr-2 w-12"></div>
            }
          </div>
        }
      </div>
    </div>
    <div class="border-gray mt-2 mb-4 ml-2 mr-2 w-12"></div>
    <div class="col-12 flex p-0">
      <div class="col-6 p-0">
        <div class="col-12 flex">
          <h4>{{ 'OrderDetails.Doctor' | translate }}</h4>
        </div>
        <div class="col-12 flex p-0">
          <div class="col-6">
            <span class="heading-label"> {{ 'OrderDetails.Name' | translate }}: </span>
          </div>
          <div class="col-6">
            <span class="large-paragraph">{{ editOrderDetails.customerName }} </span>
          </div>
        </div>
        <div class="col-12 flex p-0">
          <div class="col-6">
            <span class="heading-label"> {{ 'OrderDetails.Email' | translate }}: </span>
          </div>
          <div class="col-6">
            <span class="large-paragraph">{{ editOrderDetails.customerEmail }}</span>
          </div>
        </div>
        <div class="col-12 flex p-0">
          <div class="col-6">
            <span class="heading-label"> {{ 'OrderDetails.Id' | translate }}: </span>
          </div>
          <div class="col-6">
            <span class="large-paragraph">{{ editOrderDetails.customerDoctorId }}</span>
          </div>
        </div>
        <div class="col-12 flex p-0">
          <div class="col-6">
            <span class="heading-label"> {{ 'Profile.InstituteName' | translate }}: </span>
          </div>
          <div class="col-6">
            <span class="large-paragraph">{{ editOrderDetails.institutionName }}</span>
          </div>
        </div>
        <div class="col-12 flex p-0">
          <div class="col-6">
            <span class="heading-label">
              {{ 'Order_Info.Institution' | translate }}&nbsp;{{ 'OrderDetails.Id' | translate }}:
            </span>
          </div>
          <div class="col-6">
            <span class="large-paragraph">{{ editOrderDetails.institutionId }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="border-gray mt-2 mb-4 ml-2 mr-2 w-12"></div>
    <div class="col-12">
      <p-panel [toggleable]="true">
        <ng-template pTemplate="header">
          <h4>{{ 'OrderDetails.ClinicalHistory' | translate }}</h4>
        </ng-template>
        <ng-container
          *ngTemplateOutlet="dynamicFormTemplateList; context: {templateList: editOrderDetails.clinicalHistory}" />
      </p-panel>
    </div>

    <div class="col-12 flex justify-content-between">
      <p-button
        (onClick)="backToOrders()"
        icon="pi pi-angle-left"
        label="{{ 'OrderDetails.Back-to-orders' | translate }}"
        styleClass="p-button-outlined p-button-rounded"
        class="p-2" />
    </div>
  </div>
}

<ng-template #dynamicFormTemplateList let-templateList="templateList">
  @for (formTemplate of templateList; track formTemplate) {
    @switch (formTemplate.type) {
      @case (eDynamicFormType.HtmlTag) {
        <div class="col-12 mb-3 mt-4 p-0">
          @if (!formTemplate.label.includes(eClinicalHistoryFields.MarksMandatoryFields)) {
            @if (formTemplate.name?.split('.'); as tags) {
              @switch (tags[tags.length - 1]) {
                @case ('h5') {
                  <h5>{{ formTemplate.label }}</h5>
                }
                @case ('p') {
                  <p>{{ formTemplate.label }}</p>
                }
                @case ('hr') {
                  <p-divider styleClass="p-divider-gray" />
                }
              }
            }
          }
        </div>
      }

      @case (eDynamicFormType.InputGroup) {
        <div class="col-12 flex p-0 mb-3">
          <div class="col-3 p-0">
            <span class="test-key normal-paragraph">{{ formTemplate.label }}</span>
          </div>
          <div class="col-9 ml-3 p-0">
            <span class="clinician-comment test-value normal-paragraph">
              @for (field of formTemplate.fields; track field) {
                @if (field.type !== eDynamicFormType.InputGroupAddon) {
                  {{ field.value }} {{ field.value ? field.label : '' }}
                }
              }
            </span>
          </div>
        </div>
      }

      @case (eDynamicFormType.MultiSelect) {
        <div class="col-12 flex p-0 mb-3">
          <div class="col-3 p-0">
            <span class="input-title">{{ formTemplate.label }}</span>
          </div>
        </div>
        <div class="col-12 flex p-0">
          @if (formTemplate.value?.length <= hpoFirstPartition) {
            <div class="col-12 p-0">
              @for (hpo of formTemplate.value; track hpo) {
                <div class="mb-2">
                  <span class="hpo-terms">{{ hpo.displayLabel }}</span>
                </div>
              }
            </div>
          }
          @if (formTemplate.value?.length > hpoFirstPartition && formTemplate.value?.length <= hpoSecondPartition) {
            <div class="col-12 flex pt-0">
              <div class="col-6">
                @for (hpo of formTemplate.value; track hpo; let i = $index) {
                  @if (i < hpoFirstPartition) {
                    <div class="mb-2">
                      <span class="hpo-terms">{{
                        formTemplate.showValueInLabel
                          ? hpo.displayLabel
                          : formTemplate.value
                            ? hpo.name
                            : formTemplate.value
                      }}</span>
                    </div>
                  }
                }
              </div>
              <div class="col-6">
                @for (hpo of formTemplate.value; track hpo; let i = $index) {
                  @if (i >= hpoFirstPartition) {
                    <div class="mb-2">
                      <span class="hpo-terms">{{
                        formTemplate.showValueInLabel
                          ? hpo.displayLabel
                          : formTemplate.value
                            ? hpo.name
                            : formTemplate.value
                      }}</span>
                    </div>
                  }
                }
              </div>
            </div>
          }
          @if (formTemplate.value?.length > hpoSecondPartition) {
            <div class="col-12 flex pt-0">
              <div class="col-6">
                @for (hpo of formTemplate.value; track hpo; let i = $index) {
                  @if (i < formTemplate.value?.length / 2) {
                    <div class="mb-2">
                      <span class="hpo-terms">{{
                        formTemplate.showValueInLabel
                          ? hpo.displayLabel
                          : formTemplate.value
                            ? hpo.name
                            : formTemplate.value
                      }}</span>
                    </div>
                  }
                }
              </div>
              <div class="col-6">
                @for (hpo of formTemplate.value; track hpo; let i = $index) {
                  @if (i > formTemplate.value?.length / 2) {
                    <div class="mb-2">
                      <span class="hpo-terms">{{
                        formTemplate.showValueInLabel
                          ? hpo.displayLabel
                          : formTemplate.value
                            ? hpo.name
                            : formTemplate.value
                      }}</span>
                    </div>
                  }
                }
              </div>
            </div>
          }
        </div>
      }

      @case (eDynamicFormType.Accordion) {
        @for (accordionTab of formTemplate.fields; track accordionTab) {
          @if (accordionTab.type === eDynamicFormType.AccordionTab) {
            <p-panel [toggleable]="true">
              <ng-template #accordionHeader>
                <h5>{{ accordionTab.label }}</h5>
              </ng-template>
              <ng-container *ngTemplateOutlet="dynamicFormTemplateList; context: {templateList: accordionTab.fields}" />
            </p-panel>
          }
        }
      }

      @case (eDynamicFormType.VariableAccordion) {
        @for (accordionTab of formTemplate.fields; track accordionTab; let i = $index) {
          @if (accordionTab.type === eDynamicFormType.VariableAccordionTab) {
            <p-panel [toggleable]="true">
              <ng-template #variableAccordionHeader>
                <h5>{{ accordionTab.label + ' ' + (i + 1) }}</h5>
              </ng-template>
              <ng-container *ngTemplateOutlet="dynamicFormTemplateList; context: {templateList: accordionTab.fields}" />
            </p-panel>
          }
        }
      }

      @default {
        <div class="col-12 flex p-0 mb-3">
          <div class="col-3 p-0">
            <span class="test-key normal-paragraph">{{ formTemplate.label }}</span>
          </div>
          <div class="col-9 ml-3 p-0">
            @switch (formTemplate.type) {
              @case (eDynamicFormType.Textarea) {
                <span class="clinician-comment">{{ formTemplate.value }}</span>
              }

              @case (eDynamicFormType.Date) {
                <span class="clinician-comment test-value normal-paragraph">{{
                  formTemplate.value | date: dateFormat
                }}</span>
              }

              @case (eDynamicFormType.Select) {
                @for (option of formTemplate.options; track option) {
                  @if (formTemplate.lazy) {
                    @if (
                      option[formTemplate.optionValue ?? 'value'] ===
                      formTemplate.value[formTemplate.optionValue ?? 'value']
                    ) {
                      <span class="clinician-comment test-value normal-paragraph">
                        {{ option[formTemplate.optionLabel ?? 'label'] }}
                      </span>
                    }
                  }
                  @if (!formTemplate.lazy) {
                    @if (option.value === formTemplate.value) {
                      <span class="clinician-comment test-value normal-paragraph">
                        {{ option.label }}
                      </span>
                    }
                  }
                }
              }

              @case (eDynamicFormType.RadioButton) {
                @for (option of formTemplate.options; track option) {
                  @if (option.value === formTemplate.value) {
                    <span class="clinician-comment test-value normal-paragraph">
                      {{ option.label }}
                    </span>
                  }
                }
              }

              @case (eDynamicFormType.Checkbox) {
                @for (option of formTemplate.options; track option) {
                  @for (val of formTemplate.value; track val) {
                    @if (option.value === val) {
                      <span class="clinician-comment test-value normal-paragraph">{{ option.label }} </span>
                    }
                    &nbsp;
                  }
                }
              }

              @default {
                <span class="clinician-comment test-value normal-paragraph">{{ formTemplate.value }}</span>
              }
            }
          </div>
        </div>
      }
    }
  }
</ng-template>
